package com.milta.core.localization.translations.de

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Team",
    statusActive = "Aktiv",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    monthNames = listOf("Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"),
    enterpriseSectionLabel = "Fahrer im Team",
    enterpriseEmptyHint = "Noch keine Fahrer in Ihrem Team.",
    noEnterpriseFound = "Kein Unternehmen mit Ihrem Konto verknüpft.",
    columnHeaderDriver = "Fahrer",
    columnHeaderStatus = "Status",
    columnHeaderActions = "Aktionen",
    addDriverSectionTitle = "Fahrer hinzufügen",
    addDriverCodePlaceholder = "Milta-Code — z. B. MTA-28371",
    addDriverButton = "Diesen Fahrer hinzufügen",
    addDriverErrorInvalidCode = "Bitte geben Sie einen gültigen Code ein.",
    addDriverErrorNotFound = "Ungültiger oder bereits verwendeter Code.",
    addDriverErrorAlreadyMember = "Dieser Fahrer ist bereits Teil Ihres Teams.",
    addDriverErrorLinkedAccountIsEnterprise = "Dieses Konto ist ein Unternehmen und kann nicht als Fahrer hinzugefügt werden.",
    addDriverErrorLimitReached = "Limit erreicht: Ein Unternehmen kann nicht mehr als 10 Mitglieder haben, Sie eingeschlossen. Entfernen Sie einen Fahrer, um einen anderen hinzuzufügen.",
    addDriverErrorEnterpriseSubscriptionInactive = "Ihr Unternehmens-Abonnement ist abgelaufen: Verlängern Sie es, um einen Fahrer hinzuzufügen.",
    driverDetailTitle = "Details zum Fahrer",
    driverDetailPhoneLabel = "Telefon",
    removeDriverButton = "Entfernen",
    removeDriverDialogTitle = "Diesen Fahrer entfernen?",
    removeDriverDialogMessagePrefix = "Sie sind dabei,",
    removeDriverDialogMessageSuffix = "aus Ihrem Team zu entfernen. Das Milta-Konto des Fahrers bleibt aktiv.",
    removeDriverErrorNotFound = "Fahrer nicht gefunden.",
    removeDriverErrorOnActiveDelivery = "Dieser Fahrer befindet sich derzeit auf einer aktiven Zustellung und kann nicht entfernt werden.",
    removeDriverErrorLastOwner = "Sie sind der einzige Manager dieses Unternehmens. Fügen Sie ein weiteres Unternehmenskonto hinzu, bevor Sie sich selbst aus dem Team entfernen.",
)
